export function fadeOut(el: HTMLElement) {
  el.style.opacity = '1'

  const tick = () => {
    let val = parseFloat(el.style.opacity)
    if ((val -= 0.1) < 0) {
      el.style.display = 'none'
      el.style.opacity = ''
      return
    }
    el.style.opacity = val.toString()
    requestAnimationFrame(tick)
  }
  requestAnimationFrame(tick)
}

export function fadeIn(el: HTMLElement, display: string = 'block') {
  el.style.opacity = '0'
  el.style.display = display

  const tick = () => {
    let val = parseFloat(el.style.opacity)
    if ((val += 0.1) > 1) {
      el.style.opacity = ''
      return
    }
    el.style.opacity = val.toString()
    requestAnimationFrame(tick)
  }
  requestAnimationFrame(tick)
}
